// extracted by mini-css-extract-plugin
export default {"filters":"DataCollectorsPerformanceMapFilters_filters__B67o1"};